import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api_get } from "../../../helpers/index";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";

const TierDetail = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tier_id = searchParams.get("tier_id");

    const navigate = useNavigate();
    const route = all_routes;

    const [tierDetails, setTierDetails] = useState(null);

    useEffect(() => {
        // Fetch tier details
        const fetchTierDetails = async () => {
            try {
                const response = await api_get(`spinwheel/tier/get/${tier_id}`);
                if (response.status === 1) {
                    setTierDetails(response.data);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Failed to load tier details.",
                    });
                }
            } catch (error) {
                console.error("Error fetching tier details:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while fetching tier details.",
                });
            }
        };

        if (tier_id) {
            fetchTierDetails();
        }
    }, [tier_id]);

    if (!tierDetails) {
        return <div>Loading...</div>;
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="page-title">
                        <h4>Tier Details</h4>
                        <h6>Full details of the tier</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="prizedetails">
                                    <ul className="product-bar">
                                        <li>
                                            <h4>Tier Name</h4>
                                            <h6>{tierDetails.name}</h6>
                                        </li>
                                        <li>
                                            <h4>Description</h4>
                                            <h6>{tierDetails.description}</h6>
                                        </li>
                                        <li>
                                            <h4>Tier Sequence</h4>
                                            <h6>{tierDetails.tier_sequence}</h6>
                                        </li>
                                        <li>
                                            <h4>Probability With Rank %</h4>
                                            <h6>{tierDetails.probability_with_rank}%</h6>
                                        </li>
                                        <li>
                                            <h4>Prize</h4>
                                            <h6>{tierDetails.prize_info?.name || "N/A"}</h6>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="slider-prize-details">
                                    {tierDetails.prize_info?.image ? (
                                        <div className="slider-product">
                                            <img src={tierDetails.prize_info.image} alt="Prize image" />
                                            <h4>{tierDetails.prize_info.name}</h4>
                                        </div>
                                    ) : (
                                        <p>No prize image available</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="btn-addprize mb-4">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                onClick={() => {
                                    navigate(route.tierList);
                                }}
                            >
                                Back to Tier List
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TierDetail;
